import { Expert } from "@/types/types";

export const EXPERT_TYPE_LABELS: Record<Expert["expertType"], string> = {
  general: "General",
  interviewer: "Interviewer",
  platform: "Media",
  strategic: "Strategy",
  creative: "Creative",
  account_management: "Account Management",
};
